import { CONFIG } from '@/constants';

const config = {
  [CONFIG.PAYMENT.METHOD_KEY.BANK_TRANSFER]: 'Bonifico bancario',
  [CONFIG.PAYMENT.METHOD_KEY.CREDIT_CARD]: 'Carta di credito',
};

export default config;
